<template>
  <div>
    <van-grid column-num="1">
      <van-grid-item v-for="t in topicList" :key="t.topicId"
        :to="{ path: 'topic-detail', query: { topicId: t.topicId, buyFlag: 1 } }">
        <template #icon>
          <van-image :src="t.headImage" fit="contain"></van-image>
        </template>

        <template #text>
          <span style="font-size: 16px;padding: 4px;">{{ t.name }}</span>
        </template>
      </van-grid-item>
    </van-grid>

    <van-row style="margin-top: 16px;" v-if="topicList && topicList.length">
      <van-col span="24" style="text-align: center;font-size: 14px;text-underline:none;color: #999;">
        <router-link :to="{ name: 'user-center-update-pwd' }">找回支付密码?</router-link>
      </van-col>
    </van-row>

    <van-empty v-if="!topicList || topicList.length < 1" description="没有专题商品"></van-empty>
  </div>
</template>

<script>
import { mall_WxUser_get_TopicList_ByUser } from "@/api/goods-api"
import { Dialog } from "vant"

export default {
  name: "topic-list",

  data() {
    return {
      topicList: []
    }
  },

  created() {
    mall_WxUser_get_TopicList_ByUser().then(res => {
      this.topicList = res?.data || [];

      // 用户的卡 如未绑定专题 用户就会被引导去绑手机
      // 如果用户的卡 绑定了专题 就会展示专题列表
      if (!this.topicList || this.topicList.length < 1) {
        budo_log.info("#40 mall_WxUser_get_TopicList_ByUser, go card-mobile-bind")

        Dialog.confirm({
          title: "绑定手机",
          message: `跳转到绑定手机页面`
        }).then(() => {
          sessionStorage.setItem("rc.redirect_topic_list", "1");
          this.$router.replace({ path: 'card-mobile-bind' })
        })

        return
      }

      // 如果只有一个专题 考虑直接跳转
      // /web/topic-detail?topicId=56&buyFlag=1
      // /web/seckill-public?multipleTopicId=56
    })
  },

  methods: {
    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    },
  }
}
</script>

<style scoped></style>
